import { apiClient } from './api';

export type Role = 'SUPER_ADMIN' | 'ADMIN' | 'VOLUNTEER';

export type Permission =
  | 'volunteer:read'
  | 'volunteer:read:own'
  | 'volunteer:create'
  | 'volunteer:update'
  | 'volunteer:update:own'
  | 'volunteer:delete'
  | 'user:read'
  | 'user:create'
  | 'user:update'
  | 'user:delete'
  | 'user:assign-role'
  | 'admin:access'
  | 'admin:manage-users'
  | 'admin:manage-volunteers'
  | 'admin:view-reports';

export interface User {
  sub: string;
  email: string;
  name?: string;
  picture?: string;
  email_verified?: boolean;
  role?: Role;
  approved?: boolean;
  permissions?: Permission[];
  volunteerId?: string;
  volunteerName?: string;
}

export const authApi = {
  /**
   * Get current authenticated user
   */
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/auth/me');
    return response.data;
  },

  /**
   * Refresh the access token
   */
  refresh: async (): Promise<void> => {
    await apiClient.get('/auth/refresh');
  },

  /**
   * Sign up a new volunteer account
   */
  signup: async (data: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
  }): Promise<{ auth0Id: string; email: string; volunteerId: string }> => {
    const response = await apiClient.post('/auth/signup', data);
    return response.data;
  },

  /**
   * Request a password reset email through Auth0
   */
  forgotPassword: async (email: string): Promise<void> => {
    await apiClient.post('/auth/forgot-password', { email });
  },

  /**
   * Get the login URL (redirects to Auth0)
   */
  getLoginUrl: (): string => {
    const baseUrl =
      import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';
    return `${baseUrl}/auth/login`;
  },

  /**
   * Get the logout URL (redirects to Auth0 logout)
   */
  getLogoutUrl: (): string => {
    const baseUrl =
      import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';
    return `${baseUrl}/auth/logout`;
  },
};
